export default __webpack_public_path__ + "static/media/loading2.66dae55a.svg";